/**
 * Detects failed dynamic route-chunk / webpack loads so recovery UI can replace
 * an indefinite loadable fallback.
 *
 * @param {unknown} error
 * @returns {boolean}
 */
export function isRouteChunkLoadError(error) {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const name = error.name;
  if (name === 'ChunkLoadError') {
    return true;
  }

  const message = String(error.message || '');
  return (
    /Loading chunk [\w.-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
}
